import React from 'react';
import { Link } from 'gatsby';
import getCloudinary from '../../../../utils/getCloudinary';
import './style.scss';

const ELiquidSlide = () => (
    <div className="hero-swiper-slide e-liquid-slide container">
        <div className="e-liquid-text">
            <div className="title is-size-4-touch is-size-3-desktop has-text-white e-liquid-text__title is-spaced">
                Premium E-Liquid in 6 different flavours
            </div>
            <div className="subtitle is-size-4-touch is-size-3-desktop has-text-white e-liquid-text__description">
                FROM £10 + VAT
            </div>
            <Link className="button is-large is-success" to="/e-liquids">Shop Flavours</Link>
        </div>
        <div className="e-liquid-image-container">
            <img
                className="e-liquid-image"
                src={
                    getCloudinary().url(
                        'dashboard-uploads/berry_300_ehjjna.png',
                        { height: 478, crop: 'fit', fetch_format: 'auto' },
                    )
                }
                alt="Berry Kush E-Liquid"
            />
            <div className="variant-name">
                Berry Kush
            </div>
        </div>
    </div>
);

ELiquidSlide.propTypes = {};

export default ELiquidSlide;
